const MONTHS_IN_YEAR = 12;
/**
 * Calculates interest expense for one loan at current month
 *
 * @param loanAmount Loan amount at t=0
 * @param interestRate Interest rate
 * @returns Montly interest expense
 */
export function monthlyInterestExpense(loanAmount, interestRate) {
    return Math.round((loanAmount * interestRate) / MONTHS_IN_YEAR);
}
/**
 * Calculates monthly interest expense for all loans in mortgage.
 *
 * @param mortgage Array with all loans in mortgage
 * @returns Mortgage monthly interest expense
 */
export function calculateTotalMonthlyInterestExpense(mortgage) {
    return mortgage.reduce((acc, loan) => {
        const interest = monthlyInterestExpense(loan.amount, loan.interestRate);
        return acc + interest;
    }, 0);
}
/**
 * Calculates yearly interest expense for a loan with static monthly amortization
 *
 * @param amount Loan amount at t=0 of the loan
 * @param amortization Monthly amortization at t=0
 * @param interestRate Interest rate
 * @returns Yearly interest expense
 */
export function calculateYearlyInterestExpense(amount, monthlyAmortization, interestRate) {
    if (amount <= 0) {
        return 0;
    }
    return interestRate * (amount - 5.5 * monthlyAmortization);
}
